import {
  isDocumentVisible,
  waitUntilDocumentVisible,
} from '@/lib/tab-visibility'

const BOOT_RELOAD_KEY = 'tf-boot-chunk-reload'

// Tiny entry so restored background tabs do not parse React until focused.
// index.html stays an empty #root — no extra Loading... placeholder.
//
// The import is deferred until the tab is visible, which can be hours after
// a deploy. If the hashed chunk 404s, reload once so the tab is not left
// permanently blank (Sentry never boots either).
function boot() {
  import('./main.tsx')
    .then(() => {
      try {
        sessionStorage.removeItem(BOOT_RELOAD_KEY)
      } catch {
        // ignore
      }
    })
    .catch(() => {
      try {
        if (sessionStorage.getItem(BOOT_RELOAD_KEY)) return
        sessionStorage.setItem(BOOT_RELOAD_KEY, '1')
      } catch {
        // Storage blocked — still try a single reload.
      }
      window.location.reload()
    })
}

if (isDocumentVisible()) {
  boot()
} else {
  void waitUntilDocumentVisible().then(boot)
}
